import React, { useState } from 'react'
import { useLazyQuery } from '@apollo/client';
import moment from 'moment';
import { AGGridTable, Button } from '../../../../../../components/common'
import headers from "./header.json"
import { GET_USER_OR_CLIENTWISE_LIST } from '../../../../../../grapghQl/queries/freshDesk';
import { DownloadIcon } from '../../../../../../theme/icons';
import { NameComponent } from './CustomFields';

export const ClientWiseTable = ({ startDate = null, onCloseDialogue = () => null }) => {
  const [params, setParams] = useState({})
  const [collectClientDatas] = useLazyQuery(GET_USER_OR_CLIENTWISE_LIST, { fetchPolicy: 'no-cache' });

  const fetchDataFromAPI = async (params) => {
    const filterModel = params.api.getFilterModel()
    try {
      const { data } = await collectClientDatas({
        variables: {
          startRow: params.request.startRow,
          endRow: params.request.endRow,
          startDate: moment(startDate)?.startOf('month')?.format('YYYY-MM-DD'),
          endDate: moment(startDate)?.endOf('month')?.format('YYYY-MM-DD'),
          filterModel: filterModel
        }
      })
      const { greyTHRClientTicketsCounts: { data: results = [], total = 0 } = {} } = data || { greyTHRClientTicketsCounts: [] }

      const _res = results?.length ? results?.map(client => ({ ...client, name: client?.client?.name, _id: client?.client?.id })) : []
      params?.successCallback(_res, total);
      params?.api?.hideOverlay();
      !_res?.length && params?.api?.showNoRowsOverlay();
    } catch (error) {
      params?.api?.hideOverlay();
      params.failCallback()
    }
  }

  const datasource = {
    async getRows(params) {
      setParams(params)
      fetchDataFromAPI({ ...params })
    }
  }

  const gridOptions = {
    pagination: false,
    serverSideFilterOnServer: true,
    serverSideDatasource: datasource,
    rowModelType: "serverSide",
    cacheBlockSize: 10,
    rowHeight: 64,
    paginationPageSize: 10,
    cacheOverflowSize: 2,
    maxConcurrentDatasourceRequests: 2,
    infiniteInitialRowCount: 1,
    maxBlocksInCache: 2
  };

  const handleDownload = () => {
    const fileName = `Client wise freshdesk ticket list ${moment(startDate)?.startOf('month')?.format('YYYY-MM-DD')}-${moment(startDate)?.endOf('month')?.format('YYYY-MM-DD')}`
    params?.api?.exportDataAsExcel({ fileName: fileName?.replace(/ +/g, "_") });
  }

  const handleSearchChange = (text) => {
    Object?.keys(params?.api)?.length &&
      params?.api?.setFilterModel({ search: { filterType: "text", type: "contains", filter: text } });
  }

  const cellRenderers = {
    'client.name': NameComponent,
  };

  const cellRendererParams = {
    'client.name': { closeModal: onCloseDialogue }
  }

  const getDataHeaders = () => {
    const newheaders = [...headers] || []
    return newheaders.map(header => {
      header.cellRenderer = cellRenderers[header.field];
      header.cellRendererParams = cellRendererParams[header.field];
      return header;
    });
  }

  return (
    <div>
      <AGGridTable
        filterParams={{}}
        onChangeSearch={handleSearchChange}
        gridOptions={gridOptions}
        customComponentRight={<Button
          iconPos="r" onClick={handleDownload}
          variant="tertiary"
          className="flex border border-secondary-200 items-center justify-end p-0 mr-0 bg-transparent"
          icon={<DownloadIcon className="h-5 w-5 mr-2 mx-0 my-1.5" />} text={''} />}
        headers={getDataHeaders()}
        tableHeight="h-[25rem]"
        sidebar={false}
        placeholderText="Search"
        search={true} />
    </div>
  )
}
